export class HomeButton {
    title?: string;
    url?: string;
    position?: number;
    icon?: string;

    constructor(homeButton?: HomeButton) {
        this.title = homeButton?.title;
        this.url = homeButton?.url;
        this.position = homeButton?.position;
        this.icon = homeButton?.icon;
    }
}